/* create cookie gdpr */
function createCookie(name, value, days) {
    let expires;
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else{
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/*
    Google Tag Manager - consent v2
    type: 'update' or 'default'
    values: 'granted' or 'denied'
    docs: https://developers.google.com/tag-platform/security/guides/consent?consentmode=advanced#gtag.js_2
 */
function gtag_consent(type, values){
    if (typeof gtag === 'function') {
        gtag('consent', type, {
            'ad_personalization': values,
            'ad_storage': values,
            'ad_user_data': values,
            'analytics_storage': values
        });
    }
}

$('.js-cookie-accept-all').click(function(){

    if($('.js-cookie-marketing-checkbox').is(':checked') && $('.js-cookie-functional-checkbox').is(':checked') ){
        $('.js-cookie-save').click();
    }else{
        $('.js-cookie-marketing-checkbox').prop( 'checked', true );
        $('.js-cookie-functional-checkbox').prop( 'checked', true );
        setTimeout(
            function(){
                $('.js-cookie-save').click();
            }, 500
        );
    }
})

if( $('.js-cookie-bar-to-show').length ) {
    var cookie_bar_opened = false;
    let cookie_bar = $('.cookie-bar');
    setTimeout(function(){
        if(!cookie_bar_opened){
            cookie_bar.slideDown();
        }
    }, cookie_bar.data('delay') ?? 4000);
}

$('.js-cookie-toggle').click(function(){
    $('.cookie-bar').slideToggle();
    cookie_bar_opened = true;
})

$('.js-cookie-save').click(function(){
    if($('.js-cookie-marketing-checkbox').is(':checked')){
        createCookie('marketing_cookies', 1, 395);
        if($(this).data('consent-v2')){
            gtag_consent('update', 'granted');
        }
    }else if(readCookie('marketing_cookies')){
        createCookie('marketing_cookies', 1, -10);
        if($(this).data('consent-v2')) {
            gtag_consent('update', 'denied');
        }
    }
    if($('.js-cookie-functional-checkbox').is(':checked')){
        createCookie('functional_cookie', 1, 395);
    }else if(readCookie('functional_cookie')){
        createCookie('functional_cookie', 1, -10);
    }
    /* ak nedal oba súhlasy tak sa lišta zobrazí znovu za 6 mesiacov */
    if( $('.js-cookie-marketing-checkbox').is(':checked') && $('.js-cookie-functional-checkbox').is(':checked') ){
        createCookie('cookie_bar', 1, 395);
    }else{
        createCookie('cookie_bar', 1, 180);
    }
    $('.cookie-bar').slideUp();
})
